import React from "react";
import { motion } from "framer-motion";
import { Icon } from "./icon";

export const Services = (props) => {
  const items = props.data || [];

  return (
    <section
      id="services"
      className="on-dark section relative overflow-hidden bg-navy-950 text-white"
    >
      {/* Depth: gradient wash, blueprint grid, brand glows */}
      <div
        className="absolute inset-0 bg-gradient-to-br from-navy-950 via-navy-900 to-navy-950"
        aria-hidden="true"
      />
      <div className="grid-bg-dark mask-fade absolute inset-0 opacity-60" aria-hidden="true" />
      <div
        className="absolute -left-40 top-0 h-[32rem] w-[32rem] rounded-full bg-crimson-600/20 blur-[140px]"
        aria-hidden="true"
      />
      <div
        className="absolute -right-40 bottom-0 h-[32rem] w-[32rem] rounded-full bg-navy-500/25 blur-[140px]"
        aria-hidden="true"
      />

      <div className="container relative z-10">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow-dark">What we do</span>
          <h2 className="section-heading mt-6 text-white">
            End-to-end delivery, under
            <span className="gradient-text-light"> one roof</span>
          </h2>
          <p className="section-sub mx-auto text-center text-white/60">
            Strategy, design, engineering and operations from a single team — so nothing
            gets lost in the handoff between vendors.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((d, i) => (
            <motion.article
              key={d.name}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.07, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="card-dark-interactive group flex flex-col"
            >
              <div className="icon-tile-dark transition-all duration-500 group-hover:bg-crimson-600 group-hover:text-white group-hover:ring-crimson-500">
                <Icon name={d.icon} className="h-6 w-6" />
              </div>

              <h3 className="mt-6 text-xl font-bold text-white">{d.name}</h3>
              <p className="mt-3 flex-1 leading-relaxed text-white/60 transition-colors duration-500 group-hover:text-white/75">
                {d.text}
              </p>

              <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-crimson-300/70 transition-colors duration-500 group-hover:text-crimson-300">
                Learn more
                <Icon
                  name="arrowRight"
                  className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                />
              </span>
            </motion.article>
          ))}
        </div>

        <div className="mt-16 flex flex-col items-center gap-5 rounded-2xl border border-white/10 bg-white/[0.04] p-8 text-center backdrop-blur-sm sm:flex-row sm:justify-between sm:text-left">
          <div>
            <h3 className="text-lg font-bold text-white">
              Not sure which of these you need?
            </h3>
            <p className="mt-1.5 text-white/60">
              Tell us the problem — we'll tell you the shortest path to solving it.
            </p>
          </div>
          <a href="#contact" className="btn-primary shrink-0">
            Book a consultation
            <Icon name="arrowRight" className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
};
